<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/gmI5Uq/tc-custom/9781504079426.jpg?1705239545846" alt="This image is the cover for the book Project Keepsake"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Project Keepsake
      </h1>
      <p class="bookDescription body article font2">
        <b>Fascinating personal histories are revealed through the stories of cherished objects, in this anthology celebrating the meaningful mementos of our lives. </b><br/><br/> Amber Lanier Nagle has always been interested in keepsakes, whether her own or those she encounters in her friends’ homes. Seemingly ordinary items—a glass bluebird, a pocketknife, a dime-store locket, a faded fishing lure, a dented cake pan, a model train car—become priceless treasures when their stories are uncovered. In <i>Project Keepsake</i>, Nagle collects the tales of these objects and their beloved memories from contributors near and far.<br/><br/> “Why do you keep this?” Nagle asks. “Where did it come from?” And then she listens as the stories pour out. Told in first-person by both seasoned and aspiring writers, every essay in the anthology is unique—yet each reveals common threads that connect us all and celebrate the glorious human experience.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Amber Lanier Nagle
      </h2>
      
      <p class="authorDescription body article">Amber Lanier Nagle is a freelance writer based in Georgia. She&rsquo;s published articles in <I>Grit</I>, <I>Mother Earth News</I>, <I>Points North</I>, and many other magazines. When she isn&rsquo;t writing, Nagle spends time outdoors with her husband and works with aspiring writers.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?91f138fa